import { useMemo } from 'react';

import { stringHashCode } from '../../utils/stringHashCode';
import { AvatarSize } from './constants';
import {
  StyledBasicSubtitle,
  StyledBiggerSubtitle,
  StyledSmallSubtitle,
  StyledSmallTitle,
  Wrapper,
} from './UserAliasAvatar.styled';

export interface UserAliasModalProps {
  className?: string;
  name?: string;
  size?: AvatarSize;
  isActive?: boolean;
}

const UserAliasAvatar = ({
  name,
  size = AvatarSize.Small,
  isActive,
  className,
}: UserAliasModalProps) => {
  const hash = useMemo(() => (name ? stringHashCode(name) : undefined), [name]);

  const text = name?.slice(0, 2) ?? '';

  const TextElement = useMemo(() => {
    if (size === AvatarSize.Small) {
      return StyledSmallSubtitle;
    }
    if (size === AvatarSize.Medium) {
      return StyledBasicSubtitle;
    }
    if (size === AvatarSize.Big) {
      return StyledBiggerSubtitle;
    }

    return StyledSmallTitle;
  }, [size]);

  return (
    <Wrapper className={className} $size={size} $hash={hash} $isActive={isActive}>
      <TextElement>{text}</TextElement>
    </Wrapper>
  );
};

UserAliasAvatar.Size = AvatarSize;

export { UserAliasAvatar };
